define.alias("ember-concurrency/helpers/cancel-all", "settings/helpers/cancel-all");